import {combineReducers} from '@modifi/redux'

import companyIntroductionReducer from './company-introduction/store'
import companyFinancialsReducer from './company-financials/store'
import buyerDetailsReducer from './buyer-details/reducer'
import TradeDocumentsFormReducer from './dialogs/high-limit-doc-upload-dialog/form'

export default combineReducers({
  companyIntroduction: companyIntroductionReducer,
  companyFinancials: companyFinancialsReducer,
  buyerDetails: buyerDetailsReducer,
  tradeDocumentsForm: TradeDocumentsFormReducer,
})
